import React, { useRef,useState,useEffect } from 'react';
import { useOutletContext  } from "react-router-dom";
import { Bar } from '@ant-design/plots';
import { notification,Card ,Col,Button,Row} from 'antd';
import { useNavigate } from "react-router-dom";
import {
  ExportOutlined,
} from '@ant-design/icons';
import DashboardAPI from "../../restAPI/DashboardAPI";
import { useSelector } from "react-redux";

const TradingPartnersBarChart = ({ isDarkMode}) => {
  const [aPData, setAPDataData] = useState([]);
  const [aRData, setARDataData] = useState([]);
  const {groupId, companyId} = useOutletContext();
  const { token } = useSelector(state => state.auth);
  const notificationShown = useRef(false);
  const navigate = useNavigate();

  const openNotificationWithIcon = (type, message, description, placement) => {
          if (!notificationShown.current) {
            notification[type]({
              message: message,
              description: description,
              placement,
            });
            notificationShown.current = true;
            setTimeout(() => {
              notificationShown.current = false;
            }, 5000);
          }
  };

  const navigateToAccountReceivable = () => {
    if(localStorage.getItem('companyId') !==null)
      {
         navigate('/documentupload/AccountReceivable');
      }
      else{
          openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
      }
  };

  const navigateToAccountPayable = () => {
    if(localStorage.getItem('companyId') !==null)
      {
         navigate('/documentupload/AccountPayable');
      }
      else{
          openNotificationWithIcon('info', 'Information', "Please select a Group and Company.", 'bottomLeft');
      }
  };

  
  useEffect(() => {
    getTaxIncludingExcludingData();
  }, [groupId, companyId]);

  const getTaxIncludingExcludingData =  () =>{
    DashboardAPI.getTaxIncludingExcludingData(token, localStorage.getItem('groupId'), localStorage.getItem('companyId'))
  .then((res) => {
    if (res?.data) {
    const aPRows = [];
    const aRRows = [];

    // Check if Account Payable exists and is an array
    if (Array.isArray(res.data["Account Payable"])) {
      res.data["Account Payable"].forEach((rowValue) => {
        aPRows.push({
          supplier: formatSupplierName(rowValue.TP_Name),
          value: rowValue.totalExcludingTax,
        });
      });
      setAPDataData(aPRows);
    }

    // Check if Account Receivable exists and is an array
    if (Array.isArray(res.data["Account Receivable"])) {
      console.log("dashboard ar ap res.data",res.data)
      res.data["Account Receivable"].forEach((rowValue) => {
        aRRows.push({
          supplier: formatSupplierName(rowValue.TP_Name),
          value: rowValue.totalIncludingTax,
        });
      });
      setARDataData(aRRows);
    }

  }
  })
  .catch((err) => {
    console.log("error getting tax data :", err.message);
  });
}

  const formatSupplierName = (str) => {
    // const words = str.split(' ');
    // return words.length > 0 
    //   ? words[0] + ' ' + words.slice(1).map(word => word[0]).join(' ')
    //   : str;

    const cleanedStr = str.replace(/[\[\]()]/g, '');
    const words = cleanedStr.split(' ');
    return words.length > 0 
      ? words[0] + ' ' + words.slice(1).map(word => word[0]).join(' ')
      : cleanedStr;
  };

  // const stringToColor = (str) => {
  //    // Predefined array of colors
  // const colors = [
  //   '#4E79A7', '#F28E2B', '#E15759', '#76B7B2', '#59A14F'
  // ];
  
  // // Create a simple hash from the string to pick a consistent color
  // let hash = 0;
  // for (let i = 0; i < str.length; i++) {
  //   hash = str.charCodeAt(i) + ((hash << 5) - hash);
  // }
  
  // // Use the hash to select a color from the array
  // const index = Math.abs(hash) % colors.length;
  // return colors[index];
  // };

  const priorityColors = [
    '#4E79A7', // Dark Blue (Highest)
    '#76B7B2', // Light Blue (Second Highest)
    '#59A14F', // Green (Third)
    '#E15759', // Red (Fourth)
    '#F28E2B', // Orange (Fifth & Last)
  ];

  // Utility: map supplier -> color based on ranking
  const assignColorsByValue = (data) => {
    // Sort values high → low
    const sorted = [...data].sort((a, b) => b.value - a.value);

    // Map each supplier to a color based on rank
    const colorMap = {};
    sorted.forEach((item, index) => {
      colorMap[item.supplier] = priorityColors[index] || priorityColors[priorityColors.length - 1];
    });

    return colorMap;
  };

  // For Account Receivable
  const aRColorMap = assignColorsByValue(aRData);

  // For Account Payable
  const aPColorMap = assignColorsByValue(aPData);

  const aPConfig = {
    data: aPData, 
    theme: isDarkMode ? "classicDark" : "classic",
    xField: 'supplier',
    yField: 'value',
    height: 250,
    columnWidthRatio: 0.4,
    label: {
      content: (item) => item.value,
      style: {
        fill: isDarkMode ? '#fff' : '#000',
        opacity: 0.6,
      },
    },
    barStyle: { radius: [0, 2, 2, 0] },
    legend: {
      itemMarker: 'round',
      itemMarkerSize: 16,
      position: 'right',
      rowPadding: 5,
    },
    style: {
      columnWidthRatio: 0.6,
      radiusTopLeft: 6,
      radiusTopRight: 6,
      //fill: ({ supplier }) => stringToColor(supplier), // Auto-color based on supplier name
      fill: ({ supplier }) => aPColorMap[supplier],
    },
    annotations: [
      {
        type: 'text',
        style: {
          text: 'Total Including Tax (MYR)',
          labelTransform: 'rotate(0)',
          x: '50%',
          y: '130%',
          textAlign: 'center',
          pointerEvents: 'none',
          fontSize: 12,
          fontStyle: 'normal',
          fill: isDarkMode ? '#FFFFFF78' : '#00000078',
          }
      },
    ],
  };

  const aRConfig = {
    data:aRData,
    theme: isDarkMode ? "classicDark" : "classic",
    xField: 'supplier',
    yField: 'value',
    height: 250,
    columnWidthRatio: 0.4,
    label: {
      content: (item) => item.value,
      style: {
        fill: isDarkMode ? '#fff' : '#000',
        opacity: 0.6,
      },
    },
    barStyle: { radius: [0, 2, 2, 0] },
    legend: {
      itemMarker: 'round',
      itemMarkerSize: 16,
      position: 'right',
      rowPadding: 5,
    },
    style: {
      columnWidthRatio: 0.6,
      radiusTopLeft: 6,
      radiusTopRight: 6,
      //fill: ({ supplier }) => stringToColor(supplier), // Auto-color based on supplier name
      fill: ({ supplier }) => aRColorMap[supplier],
    },
    annotations: [
      {
        type: 'text',
        style: {
          text: 'Total Including Tax (MYR)',
          labelTransform: 'rotate(0)',
          x: '50%',
          y: '130%',
          textAlign: 'center',
          pointerEvents: 'none',
          fontSize: 12,
          fontStyle: 'normal',
          fill: isDarkMode ? '#FFFFFF78' : '#00000078',
          }
      },
    ],
  };

  return (
    <div>
      <Row gutter={16}>
      <Col xl={12} >
          <div class="border-container">
            <Button type="primary" variant="dashed" onClick={navigateToAccountReceivable} className="card-button" size="large" icon={<ExportOutlined />} shape="circle">
            </Button>
    <Card title="Account Receivable" style={{ width: '100%' }}>
          <Bar {...aRConfig} />
    </Card>
    </div>
    </Col>
    <Col xl={12}>
          <div class="border-container">
            <Button type="primary" variant="dashed" onClick={navigateToAccountPayable} className="card-button" size="large" icon={<ExportOutlined />} shape="circle">
            </Button>
    <Card title="Account Payable" style={{ width: '100%' }}>
      <Bar {...aPConfig} />
    </Card>
    </div>
    </Col>
    </Row>
    </div>
  );
};

export default TradingPartnersBarChart;